import React from 'react'
import Topbar from '../Components/Topbar'
import Navbar from '../Components/Navbar'
import Pagebooking from './Pagebooking'
import Service from '../Home/Service'
import Booking from '../Home/Booking'
import Call from './Call'
import Footer from '../Home/Footer'
import { CartProvider } from 'react-use-cart'

function AllBooking() {
  return (
    <CartProvider>
        <Topbar/>
        <Navbar/>
        <Pagebooking/>
        <Service/>
        <Booking/>
        <Call/>
        <Footer/>
    </CartProvider>
  )
}

export default AllBooking